import React, { useEffect, useRef, useState } from 'react';
import './css/filter.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Stack from 'react-bootstrap/Stack';
import ListGroup from 'react-bootstrap/ListGroup';
import Collapse from 'react-bootstrap/Collapse';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import useAuth from 'utils/utils';
import ReactGA from 'react-ga4';
import { shopType, conditionType } from 'utils/types';
import ConditionsInfo from './Conditions';
import FilterSection from './filter/FilterSection';
import GenderFilter from './filter/GenderFilter';
import SizeFilter from './filter/SizeFilter';
import ColorFilters from './filter/ColorFilter';

function Filter(props) {
  const {
    isMenuActive,
    onOverLayClick,
    filter,
    setSearchParams,
    sellerProp,
    settingsCategories,
    type,
  } = props;

  const authState = useAuth();

  const [lastQuery, setLastQuery] = useState();

  const [size, setSize] = useState([]);
  const [sizeHat, setSizeHat] = useState([]);
  const [category, setCategory] = useState([]);
  const [categorydetail, setCategorydetail] = useState([]);
  const [gender, setGender] = useState([]);
  const [brand, setBrand] = useState([]);
  const [sellerNumber, setSellerNumber] = useState([]);
  const [itemNumber, setItemNumber] = useState('');
  const [count, setCount] = useState(0);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [condition, setCondition] = useState([]);
  const [createdAt, setCreatedAt] = useState('');
  const [withInactive, setWithInactive] = useState(false);
  const [onlyInactive, setOnlyInactive] = useState(false);
  const [onlyRetoured, setOnlyRetoured] = useState(false);
  const [onlySold, setOnlySold] = useState(false);
  const [onlySale, setOnlySale] = useState(false);
  const [theme, setTheme] = useState([]);
  const [color, setColor] = useState([]);

  const [genderOpen, setGenderOpen] = useState(false);
  const [sizeOpen, setSizeOpen] = useState(false);
  const [sizeHatOpen, setSizeHatOpen] = useState(false);
  const [brandOpen, setBrandOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [categoryDetailOpen, setCategoryDetailOpen] = useState(false);
  const [conditionOpen, setConditionOpen] = useState(false);
  const [createdAtOpen, setCreatedAtOpen] = useState(false);
  const [themeOpen, setThemeOpen] = useState(false);
  const [colorOpen, setColorOpen] = useState(false);
  const [themeAdminOpen, setThemeAdminOpen] = useState(false);

  const [sellerOpen, setSellerOpen] = useState(false);
  const [itemNumberOpen, setItemNumberOpen] = useState(false);

  const [categoryInputFilter, setCategoryInputFilter] = useState('');
  const [categoryDetailInputFilter, setCategoryDetailInputFilter] =
    useState('');

  //const [filteredCategories, setFilteredCategories] = useState();
  const [brandInputFilter, setBrandInputFilter] = useState('');
  const [sellerInputFilter, setSellerInputFilter] = useState('');
  const [themeInputFilter, setThemeInputFilter] = useState('');
  const [colorInputFilter, setColorInputFilter] = useState('');

  const [showCollapsible, setShowCollapsible] = useState({});
  const toggleCollapsable = (id) => () => {
    setShowCollapsible((set) => ({
      ...set,
      [id]: !set[id],
    }));
  };

  const { search } = useLocation();
  const sp = new URLSearchParams(search);

  const didMount = useRef(false);

  useEffect(() => {
    const sizeFilter = sp.getAll('size') ? sp.getAll('size') : [];
    const sizeHatFilter = sp.getAll('sizeHat') ? sp.getAll('sizeHat') : [];
    const categoryFilter = sp.getAll('category') ? sp.getAll('category') : [];
    const genderFilter = sp.getAll('gender') ? sp.getAll('gender') : [];
    const brandFilter = sp.getAll('brand') ? sp.getAll('brand') : [];
    const conditionFilter = sp.getAll('condition')
      ? sp.getAll('condition')
      : [];
    const sellerFilter = sp.getAll('sellerNumber')
      ? sp.getAll('sellerNumber')
      : [];
    const categorydetailFilter = sp.getAll('categorydetail')
      ? sp.getAll('categorydetail')
      : [];
    const itemNumberFilter =
      sp.getAll('itemNumber').length > 0 ? sp.getAll('itemNumber') : '';
    const createdAtFilter =
      sp.getAll('createdAt').length > 0 ? sp.getAll('createdAt') : '';

    const withInactiveFilter =
      sp.getAll('withInactive').length > 0 ? true : false;

    const onlyInactiveFilter =
      sp.getAll('onlyInactive').length > 0 ? true : false;

    const onlyRetouredFilter =
      sp.getAll('onlyRetoured').length > 0 ? true : false;

    const onlySaleFilter = sp.getAll('sale').length > 0 ? true : false;
    const onlySoldFilter = sp.getAll('onlySold').length > 0 ? true : false;
    const themeFilter = sp.getAll('theme') ? sp.getAll('theme') : [];
    const colorFilter = sp.getAll('color') ? sp.getAll('color') : [];

    setSize(sizeFilter);
    setSizeHat(sizeHatFilter);
    setCategory(categoryFilter);
    setGender(genderFilter);
    setBrand(brandFilter);
    setCondition(conditionFilter);
    setSellerNumber(sellerFilter);
    setCategorydetail(categorydetailFilter);
    setItemNumber(itemNumberFilter);
    setCreatedAt(createdAtFilter);
    setWithInactive(withInactiveFilter);
    setOnlyInactive(onlyInactiveFilter);
    setOnlyRetoured(onlyRetouredFilter);
    setOnlySale(onlySaleFilter);
    setTheme(themeFilter);
    setColor(colorFilter);
    setOnlySold(onlySoldFilter);
    /*
    sizeFilter.map((s) => {
      return (document.getElementById(s).checked = true);
    });
    */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const query =
        size.map((s) => `size=${s}&`).join('') +
        sizeHat.map((s) => `sizeHat=${s}&`).join('') +
        category.map((c) => `category=${encodeURIComponent(c)}&`).join('') +
        gender.map((g) => `gender=${g}&`).join('') +
        brand.map((b) => `brand=${encodeURIComponent(b)}&`).join('') +
        condition.map((c) => `condition=${c}&`).join('') +
        theme.map((t) => `theme=${encodeURIComponent(t)}&`).join('') +
        color.map((c) => `color=${encodeURIComponent(c)}&`).join('') +
        sellerNumber
          .map((s) => `sellerNumber=${encodeURIComponent(s)}&`)
          .join('') +
        categorydetail
          .map((g) => `categorydetail=${g}&`)
          .join('')
          .concat(
            itemNumber && itemNumber !== '' ? `itemNumber=${itemNumber}&` : ''
          )
          .concat(
            createdAt && createdAt !== '' ? `createdAt=${createdAt}&` : ''
          )
          .concat(withInactive ? `withInactive=true&` : ``)
          .concat(onlyInactive ? `onlyInactive=true&` : ``)
          .concat(onlyRetoured ? `onlyRetoured=true&` : ``)
          .concat(onlySold ? `onlySold=true&` : ``)
          .concat(onlySale ? `sale` : ``);

      const queryFilteredBrands =
        size.map((s) => `size=${s}&`).join('') +
        sizeHat.map((s) => `sizeHat=${s}&`).join('') +
        category.map((c) => `category=${encodeURIComponent(c)}&`).join('') +
        gender.map((g) => `gender=${g}&`).join('') +
        condition.map((c) => `condition=${c}&`).join('') +
        theme.map((t) => `theme=${encodeURIComponent(t)}&`).join('') +
        color.map((c) => `color=${encodeURIComponent(c)}&`).join('') +
        sellerNumber
          .map((s) => `sellerNumber=${encodeURIComponent(s)}&`)
          .join('') +
        categorydetail
          .map((g) => `categorydetail=${g}&`)
          .join('')
          .concat(
            itemNumber && itemNumber !== '' ? `itemNumber=${itemNumber}` : ''
          )
          .concat(createdAt && createdAt !== '' ? `createdAt=${createdAt}` : '')
          .concat(withInactive ? `withInactive=true` : ``)
          .concat(onlyInactive ? `onlyInactive=true` : ``)
          .concat(onlyRetoured ? `onlyRetoured=true` : ``)
          .concat(onlySold ? `onlySold=true` : ``)
          .concat(onlySale ? `sale` : ``);

      if (lastQuery !== '' || lastQuery !== query) {
        setLastQuery(query);
        const { data } = await axios.get(
          `/api/products/count?type=${type}&${query}`
        );
        setCount(data.length > 0 ? data[0].amount : 0);

        const filteredData = await axios.get(
          `/api/products/count?type=${type}&${queryFilteredBrands}`
        );
        setFilteredBrands(
          filteredData.data.length > 0 ? filteredData.data[0].brands : []
        );
      }
    };
    if (didMount.current) {
      fetchData();
    } else {
      didMount.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    size,
    sizeHat,
    category,
    gender,
    condition,
    brand,
    sellerNumber,
    categorydetail,
    itemNumber,
    createdAt,
    withInactive,
    onlyInactive,
    onlyRetoured,
    onlySale,
    onlySold,
    theme,
    color,
  ]);

  const updateFromUpperCategory = (e) => {
    const checked = !Object.keys(filter.filter[e]).some((v) =>
      category.includes(v)
    );
    var tmpCat = category;
    Object.keys(filter.filter[e]).forEach((c) => {
      const idx = tmpCat.indexOf(c);
      checked ? idx === -1 && tmpCat.push(c) : idx > -1 && tmpCat.splice(idx);
    });
    setCategory([...tmpCat]);
  };

  return (
    <Modal
      size="lg"
      centered
      show={isMenuActive}
      onHide={onOverLayClick}
      className="font-poppins"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="d-flex justify-content-center">
          <div
            className="btn_action mb-3"
            onClick={() => {
              setSearchParams({
                size,
                sizeHat,
                category,
                gender,
                brand,
                condition,
                sellerNumber,
                categorydetail,
                ...(itemNumber && { itemNumber }),
                ...(createdAt && { createdAt }),
                ...(withInactive && { withInactive }),
                ...(onlyInactive && { onlyInactive }),
                ...(onlyRetoured && { onlyRetoured }),
                ...(onlySold && { onlySold }),
                ...(onlySale && { sale: '' }),
                theme,
                color,
              });
              size.length > 0 && ReactGA.event(`FGröße: ${size.join('_')}`);
              sizeHat.length > 0 &&
                ReactGA.event(`FGrößeHut: ${sizeHat.join('_')}`);
              category.length > 0 &&
                ReactGA.event(`FKat: ${category.join('_')}`);
              gender.length > 0 &&
                ReactGA.event(`FGender: ${gender.join('_')}`);
              brand.length > 0 && ReactGA.event(`FMarke: ${brand.join('_')}`);
              condition.length > 0 &&
                ReactGA.event(`FZustand: ${condition.join('_')}`);
              theme.length > 0 && ReactGA.event(`FThema: ${theme.join('_')}`);
              color.length > 0 && ReactGA.event(`FFarbe: ${color.join('_')}`);
              onOverLayClick();
            }}
          >
            {`Anwenden (${count})`}
          </div>
          {/*</Link>*/}
        </Row>
        <Row className="d-flex justify-content-center">
          <div
            className="btn_action mb-4"
            onClick={() => {
              setSize([]);
              setSizeHat([]);
              setCategory([]);
              setGender([]);
              setBrand([]);
              setSellerNumber([]);
              setCategorydetail([]);
              setCondition([]);
              setItemNumber('');
              setCreatedAt('');
              setWithInactive(false);
              setOnlyInactive(false);
              setOnlyRetoured(false);
              setOnlySold(false);
              setOnlySale(false);
              setBrandInputFilter('');
              setCategoryDetailInputFilter('');
              setCategoryInputFilter('');
              setTheme([]);
              setColor([]);
              setThemeInputFilter('');
            }}
          >
            {`Filter löschen`}
          </div>
          {/*</Link>*/}
        </Row>
        <ListGroup variant="flush" className="mx-3 mb-10">
          <ListGroup.Item>
            <Form>
              <div
                className="filter_header my-1 d-flex justify-content-between align-items-center"
                onClick={() => {
                  setOnlySale(!onlySale);
                }}
              >
                Sale
                <Form.Check
                  className="d-flex justify-content-end align-items-center"
                  label=""
                  name="group1"
                  type="checkbox"
                  id={`ssv-checkbox-1`}
                  checked={onlySale}
                  onChange={(e) => {
                    setOnlySale(e.target.checked);
                  }}
                />
              </div>
            </Form>
          </ListGroup.Item>

          <FilterSection
            title="Geschlecht"
            isOpen={genderOpen}
            toggle={() => setGenderOpen(!genderOpen)}
          >
            <GenderFilter gender={gender} setGender={setGender} />
          </FilterSection>
          <ListGroup.Item>
            <div
              className="filter_header my-1 d-flex justify-content-between align-items-center"
              onClick={() => setConditionOpen(!conditionOpen)}
            >
              Zustand
              <FontAwesomeIcon
                icon={`${conditionOpen ? 'angle-up' : 'angle-down'}`}
                size="lg"
              />
            </div>

            <Collapse in={conditionOpen}>
              <div>
                <span className="ms-2">
                  <ConditionsInfo />
                </span>
                <Stack
                  direction="horizontal"
                  gap={1}
                  style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}
                  className="justify-content-center"
                >
                  <input
                    id="condition-geliebt"
                    name="condition-geliebt"
                    type="radio"
                    className="btn-check"
                    value={conditionType.Geliebt}
                    checked={condition.includes(conditionType.Geliebt)}
                    onClick={(e) => {
                      condition.includes(e.target.value)
                        ? setCondition(
                            condition.filter((c) => c !== e.target.value)
                          )
                        : setCondition((condition) => [
                            ...condition,
                            e.target.value,
                          ]);
                    }}
                    onChange={(e) => {}}
                  />
                  <label
                    htmlFor="condition-geliebt"
                    className="btn-filterSize px-3"
                  >
                    {conditionType.Geliebt}
                  </label>
                  <input
                    id="condition-gut"
                    name="condition-gut"
                    type="radio"
                    className="btn-check"
                    value={conditionType.Gut}
                    checked={condition.includes(conditionType.Gut)}
                    onClick={(e) => {
                      condition.includes(e.target.value)
                        ? setCondition(
                            condition.filter((c) => c !== e.target.value)
                          )
                        : setCondition((condition) => [
                            ...condition,
                            e.target.value,
                          ]);
                    }}
                    onChange={(e) => {}}
                  />
                  <label
                    htmlFor="condition-gut"
                    className="btn-filterSize px-3"
                  >
                    {conditionType.Gut}
                  </label>
                  <input
                    id="condition-neu"
                    name="condition-neu"
                    type="radio"
                    className="btn-check"
                    value={conditionType.SehrGut}
                    checked={condition.includes(conditionType.SehrGut)}
                    onClick={(e) => {
                      condition.includes(e.target.value)
                        ? setCondition(
                            condition.filter((c) => c !== e.target.value)
                          )
                        : setCondition((condition) => [
                            ...condition,
                            e.target.value,
                          ]);
                    }}
                    onChange={(e) => {}}
                  />
                  <label
                    htmlFor="condition-neu"
                    className="btn-filterSize px-3"
                  >
                    {conditionType.SehrGut}
                  </label>
                </Stack>
              </div>
            </Collapse>
          </ListGroup.Item>
          {type === shopType.Kleidung || type === shopType.Schlafsack ? (
            <FilterSection
              title="Größe"
              isOpen={sizeOpen}
              toggle={() => setSizeOpen(!sizeOpen)}
            >
              <SizeFilter
                sizes={filter.sizes}
                selectedSizes={size}
                setSelectedSizes={setSize}
                exclude={['Onesize']}
              />
            </FilterSection>
          ) : (
            <>
              {(type === shopType.Accessoires ||
                window.location.pathname.startsWith('/admin')) && (
                <>
                  <FilterSection
                    title="Größe (Konfektion)"
                    isOpen={sizeOpen}
                    toggle={() => setSizeOpen(!sizeOpen)}
                  >
                    <SizeFilter
                      sizes={filter.sizes}
                      selectedSizes={size}
                      setSelectedSizes={setSize}
                    />
                  </FilterSection>
                  <FilterSection
                    title="Größe (Hut)"
                    isOpen={sizeHatOpen}
                    toggle={() => setSizeHatOpen(!sizeHatOpen)}
                  >
                    <SizeFilter
                      sizes={filter.sizesHut}
                      selectedSizes={sizeHat}
                      setSelectedSizes={setSizeHat}
                      idPrefix="hut_"
                    />
                  </FilterSection>
                </>
              )}
            </>
          )}
          <ListGroup.Item>
            <div
              className="filter_header my-1 d-flex justify-content-between align-items-center"
              onClick={() => setBrandOpen(!brandOpen)}
            >
              Marken
              <FontAwesomeIcon
                icon={`${brandOpen ? 'angle-up' : 'angle-down'}`}
                size="lg"
              />
            </div>
            <Collapse in={brandOpen}>
              <Stack
                direction="horizontal"
                gap={1}
                style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}
                className="justify-content-center"
              >
                <input
                  type="search"
                  onChange={(e) => setBrandInputFilter(e.target.value)}
                  className="filter-checkbox-input w-100 mx-3 mt-3 mb-1 p-1"
                  placeholder="Suche..."
                  value={brandInputFilter}
                  autoComplete="off"
                  autoCorrect="off"
                />
                <div className="w-100 mx-3 filter-checkbox-list">
                  {filteredBrands
                    .sort((a, b) =>
                      a.localeCompare(b, undefined, { sensitivity: 'base' })
                    )
                    .filter((b) =>
                      brandInputFilter !== ''
                        ? b
                            .toLowerCase()
                            .includes(brandInputFilter.toLowerCase())
                        : b
                    )
                    .map((b) => {
                      return (
                        <Form key={b}>
                          <Form.Check
                            type="checkbox"
                            id={`cb-brand-${b}`}
                            label={b}
                            value={b}
                            checked={brand.includes(b) || false}
                            className="filter-checkbox-list__input mx-2"
                            onClick={() => {}}
                            onChange={(e) => {
                              const idx = brand.indexOf(e.target.value);
                              e.target.checked
                                ? idx === -1 &&
                                  setBrand([...brand, e.target.value])
                                : idx > -1 &&
                                  setBrand(brand.filter((br) => br !== b));
                            }}
                          />
                        </Form>
                      );
                    })}
                </div>
              </Stack>
            </Collapse>
          </ListGroup.Item>
          {type === shopType.Kleidung && (
            <ListGroup.Item>
              <div
                className="filter_header my-1 d-flex justify-content-between align-items-center"
                onClick={() => setCategoryOpen(!categoryOpen)}
              >
                Kategorien
                <FontAwesomeIcon
                  icon={`${categoryOpen ? 'angle-up' : 'angle-down'}`}
                  size="lg"
                />
              </div>
              <Collapse in={categoryOpen}>
                <Stack
                  direction="horizontal"
                  gap={1}
                  style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}
                  className="justify-content-center"
                >
                  <input
                    type="text"
                    onChange={(e) => setCategoryInputFilter(e.target.value)}
                    className="filter-checkbox-input w-100 mx-3 mt-3 mb-1"
                    placeholder="Suche..."
                    value={categoryInputFilter}
                  />
                  <div className="w-100 mx-3">
                    {Object.keys(filter.filter)
                      .sort()
                      .filter((c) =>
                        categoryInputFilter !== ''
                          ? Object.keys(filter.filter[c]).filter((d) =>
                              filter.filter[c][d].some((a) =>
                                a
                                  .toLowerCase()
                                  .includes(categoryInputFilter.toLowerCase())
                              )
                            ).length > 0
                            ? c
                            : ''
                          : c
                      )
                      .map((oc) => (
                        <React.Fragment key={oc}>
                          <div className="btn_filter-checkbox">
                            <div
                              className="w-100"
                              onClick={() => updateFromUpperCategory(oc)}
                            >
                              <Form.Check
                                type="checkbox"
                                id={`cb-category-${oc}`}
                                label={oc}
                                value={oc}
                                checked={
                                  Object.keys(filter.filter[oc]).some((v) =>
                                    category.includes(v)
                                  ) || false
                                }
                                className={`d-flex align-items-center w-100 ${
                                  Object.keys(filter.filter[oc]).some((v) =>
                                    category.includes(v)
                                  ) &&
                                  !Object.keys(filter.filter[oc]).every((v) =>
                                    category.includes(v)
                                  )
                                    ? 'semichecked'
                                    : ''
                                }`}
                                style={{ pointerEvents: 'none' }}
                                readOnly
                              />
                            </div>
                            <div
                              className="filter_header filter_header_category my-1 d-flex justify-content-between align-items-center"
                              onClick={toggleCollapsable(oc)}
                            >
                              <FontAwesomeIcon
                                icon={`${
                                  showCollapsible[oc]
                                    ? 'angle-up'
                                    : 'angle-down'
                                }`}
                                size="lg"
                              />
                            </div>
                          </div>
                          <Collapse in={showCollapsible[oc]}>
                            <div>
                              {Object.keys(filter.filter[oc])
                                .sort()
                                .filter((c) =>
                                  categoryInputFilter !== ''
                                    ? c
                                        .toLowerCase()
                                        .includes(
                                          categoryInputFilter.toLowerCase()
                                        )
                                      ? c
                                      : filter.filter[oc][c].some((a) =>
                                          a
                                            .toLowerCase()
                                            .includes(
                                              categoryInputFilter.toLowerCase()
                                            )
                                        )
                                    : c
                                )
                                .map((c) => {
                                  return (
                                    <Form key={c}>
                                      <Form.Check
                                        type="checkbox"
                                        id={`cb-category-${c}`}
                                        label={c}
                                        value={c}
                                        checked={category.includes(c) || false}
                                        className="filter-checkbox-list__input ms-5 ps-3"
                                        onChange={(e) => {
                                          const idx = category.indexOf(
                                            e.target.value
                                          );
                                          e.target.checked
                                            ? idx === -1 &&
                                              setCategory([
                                                ...category,
                                                e.target.value,
                                              ])
                                            : idx > -1 &&
                                              setCategory(
                                                category.filter(
                                                  (cc) => cc !== c
                                                )
                                              );
                                        }}
                                      />
                                    </Form>
                                  );
                                })}
                            </div>
                          </Collapse>
                        </React.Fragment>
                      ))}
                  </div>
                </Stack>
              </Collapse>
            </ListGroup.Item>
          )}
          <ListGroup.Item>
            <div
              className="filter_header my-1 d-flex justify-content-between align-items-center"
              onClick={() => setThemeOpen(!themeOpen)}
            >
              Thema / Motiv
              <FontAwesomeIcon
                icon={`${themeOpen ? 'angle-up' : 'angle-down'}`}
                size="lg"
              />
            </div>
            <Collapse in={themeOpen}>
              <Stack
                direction="horizontal"
                gap={1}
                style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}
                className="justify-content-center"
              >
                <input
                  type="search"
                  onChange={(e) => setThemeInputFilter(e.target.value)}
                  className="filter-checkbox-input w-100 mx-3 mt-3 mb-1 p-1"
                  placeholder="Suche..."
                  value={themeInputFilter}
                  autoComplete="off"
                  autoCorrect="off"
                />
                <div className="w-100 mx-3 filter-checkbox-list">
                  {filter.themes
                    .sort((a, b) =>
                      a.localeCompare(b, undefined, { sensitivity: 'base' })
                    )
                    .filter((b) =>
                      themeInputFilter !== ''
                        ? b
                            .toLowerCase()
                            .includes(themeInputFilter.toLowerCase())
                        : b
                    )
                    .map((b) => {
                      return (
                        <Form key={b}>
                          <Form.Check
                            type="checkbox"
                            id={`cb-theme-${b}`}
                            label={b}
                            value={b}
                            checked={theme.includes(b) || false}
                            className="filter-checkbox-list__input mx-2"
                            onChange={(e) => {
                              const idx = theme.indexOf(e.target.value);
                              e.target.checked
                                ? idx === -1 &&
                                  setTheme([...theme, e.target.value])
                                : idx > -1 &&
                                  setTheme(theme.filter((br) => br !== b));
                            }}
                          />
                        </Form>
                      );
                    })}
                </div>
              </Stack>
            </Collapse>
          </ListGroup.Item>
          <FilterSection
            title="Farbe"
            isOpen={colorOpen}
            toggle={() => setColorOpen(!colorOpen)}
          >
            <ColorFilters
              colors={filter.colors}
              selectedColors={color}
              setSelectedColors={setColor}
            />
          </FilterSection>
          {window.location.pathname.startsWith('/admin') &&
            authState.isAdmin && (
              <React.Fragment>
                <ListGroup.Item>
                  <div
                    className="filter_header my-1 d-flex justify-content-between align-items-center"
                    onClick={() => setCategoryDetailOpen(!categoryDetailOpen)}
                  >
                    Kategorien (detailiert)
                    <FontAwesomeIcon
                      icon={`${categoryDetailOpen ? 'angle-up' : 'angle-down'}`}
                      size="lg"
                    />
                  </div>
                  <Collapse in={categoryDetailOpen}>
                    <Stack
                      direction="horizontal"
                      gap={1}
                      style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}
                      className="justify-content-center"
                    >
                      <input
                        type="text"
                        onChange={(e) =>
                          setCategoryDetailInputFilter(e.target.value)
                        }
                        className="filter-checkbox-input w-100 mx-3 mt-3 mb-1"
                        placeholder="Suche..."
                      />
                      <div className="w-100 mx-3 filter-checkbox-list">
                        {settingsCategories &&
                          Object.keys(settingsCategories).map((uc) => {
                            return settingsCategories[uc]
                              .sort()
                              .filter((c) =>
                                categoryDetailInputFilter !== ''
                                  ? c
                                      .toLowerCase()
                                      .includes(
                                        categoryDetailInputFilter.toLowerCase()
                                      )
                                  : c
                              )
                              .map((c) => {
                                return (
                                  <Form key={c}>
                                    <Form.Check
                                      type="checkbox"
                                      id={`cb-categorydetail-${c}`}
                                      label={c}
                                      value={c}
                                      checked={
                                        categorydetail.includes(c) || false
                                      }
                                      className="filter-checkbox-list__input mx-2"
                                      onChange={(e) => {
                                        const idx = categorydetail.indexOf(
                                          e.target.value
                                        );
                                        e.target.checked
                                          ? idx === -1 &&
                                            setCategorydetail([
                                              ...categorydetail,
                                              e.target.value,
                                            ])
                                          : idx > -1 &&
                                            setCategorydetail(
                                              categorydetail.filter(
                                                (cc) => cc !== c
                                              )
                                            );
                                      }}
                                    />
                                  </Form>
                                );
                              });
                          })}
                      </div>
                    </Stack>
                  </Collapse>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div
                    className="filter_header my-1 d-flex justify-content-between align-items-center"
                    onClick={() => setThemeAdminOpen(!themeAdminOpen)}
                  >
                    Thema / Motiv (admin)
                    <FontAwesomeIcon
                      icon={`${themeAdminOpen ? 'angle-up' : 'angle-down'}`}
                      size="lg"
                    />
                  </div>
                  <Collapse in={themeAdminOpen}>
                    <Stack
                      direction="horizontal"
                      gap={1}
                      style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}
                      className="justify-content-center"
                    >
                      <input
                        type="text"
                        onChange={(e) => setThemeInputFilter(e.target.value)}
                        className="filter-checkbox-input w-100 mx-3 mt-3 mb-1"
                        placeholder="Suche..."
                        value={themeInputFilter}
                        autoComplete="off"
                        autoCorrect="off"
                      />
                      <div className="w-100 mx-3 filter-checkbox-list">
                        {filter.themes
                          .sort((a, b) =>
                            a.localeCompare(b, undefined, {
                              sensitivity: 'base',
                            })
                          )
                          .filter((b) =>
                            themeInputFilter !== ''
                              ? b
                                  .toLowerCase()
                                  .includes(themeInputFilter.toLowerCase())
                              : b
                          )
                          .map((b) => {
                            return (
                              <Form key={b + '_Admin'}>
                                <Form.Check
                                  type="checkbox"
                                  id={`cb-theme-${b}`}
                                  label={b}
                                  value={b}
                                  checked={theme.includes(b) || false}
                                  className="filter-checkbox-list__input mx-2"
                                  onChange={(e) => {
                                    const idx = theme.indexOf(e.target.value);
                                    e.target.checked
                                      ? idx === -1 &&
                                        setTheme([...theme, e.target.value])
                                      : idx > -1 &&
                                        setTheme(
                                          theme.filter((br) => br !== b)
                                        );
                                  }}
                                />
                              </Form>
                            );
                          })}
                      </div>
                    </Stack>
                  </Collapse>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div
                    className="filter_header my-1 d-flex justify-content-between align-items-center"
                    onClick={() => setSellerOpen(!sellerOpen)}
                  >
                    Verkäufer
                    <FontAwesomeIcon
                      icon={`${sellerOpen ? 'angle-up' : 'angle-down'}`}
                      size="lg"
                    />
                  </div>
                  <Collapse in={sellerOpen}>
                    <Stack
                      direction="horizontal"
                      gap={1}
                      style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}
                      className="justify-content-center"
                    >
                      <input
                        type="text"
                        onChange={(e) => setSellerInputFilter(e.target.value)}
                        className="filter-checkbox-input w-100 mx-3 mt-3 mb-1"
                        placeholder="Suche..."
                      />
                      <div className="w-100 mx-3 filter-checkbox-list">
                        {sellerProp &&
                          sellerProp
                            .filter((c) =>
                              sellerInputFilter !== ''
                                ? c.name
                                    .toLowerCase()
                                    .includes(sellerInputFilter.toLowerCase())
                                : c
                            )
                            .map((c) => {
                              return (
                                <Form key={c.number}>
                                  <Form.Check
                                    type="checkbox"
                                    id={`cb-seller-${c.number}`}
                                    label={
                                      c.name !== ''
                                        ? c.number + ' (' + c.name + ')'
                                        : c.number
                                    }
                                    value={c.number}
                                    checked={sellerNumber.includes(
                                      c.number.toString()
                                    )}
                                    className="filter-checkbox-list__input mx-2"
                                    onChange={(e) => {
                                      const idx = sellerNumber.indexOf(
                                        e.target.value
                                      );
                                      e.target.checked
                                        ? idx === -1 &&
                                          setSellerNumber([
                                            ...sellerNumber,
                                            e.target.value,
                                          ])
                                        : idx > -1 &&
                                          setSellerNumber(
                                            sellerNumber.filter(
                                              (cc) => cc !== c.number.toString()
                                            )
                                          );
                                    }}
                                  />
                                </Form>
                              );
                            })}
                      </div>
                    </Stack>
                  </Collapse>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div
                    className="filter_header my-1 d-flex justify-content-between align-items-center"
                    onClick={() => setItemNumberOpen(!itemNumberOpen)}
                  >
                    Artikelnummer
                    <FontAwesomeIcon
                      icon={`${itemNumberOpen ? 'angle-up' : 'angle-down'}`}
                      size="lg"
                    />
                  </div>
                  <Collapse in={itemNumberOpen}>
                    <Stack
                      direction="horizontal"
                      gap={1}
                      style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}
                      className="justify-content-center"
                    >
                      <input
                        type="text"
                        value={itemNumber}
                        onChange={(e) => setItemNumber(e.target.value)}
                        className="filter-checkbox-input w-100 mx-3 mt-3 mb-1"
                        placeholder="Artikelnummer z. B. 'V001A0001'"
                      />
                    </Stack>
                  </Collapse>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div
                    className="filter_header my-1 d-flex justify-content-between align-items-center"
                    onClick={() => setCreatedAtOpen(!createdAtOpen)}
                  >
                    Bis Erstellungsdatum
                    <FontAwesomeIcon
                      icon={`${createdAtOpen ? 'angle-up' : 'angle-down'}`}
                      size="lg"
                    />
                  </div>
                  <Collapse in={createdAtOpen}>
                    <Form.Control
                      type="date"
                      value={createdAt}
                      onChange={(e) => setCreatedAt(e.target.value)}
                      id="createdAt"
                    />
                  </Collapse>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Form>
                    <div className="filter_header my-1 d-flex justify-content-between align-items-center">
                      Mit inaktiven Artikeln
                      <Form.Check
                        className=""
                        label=""
                        name="grp-set-with-inactive"
                        type="checkbox"
                        id={`reverse-checkbox-1`}
                        checked={withInactive}
                        onChange={(e) => {
                          setWithInactive(e.target.checked);
                          setOnlyInactive(false);
                          setOnlyRetoured(false);
                          setOnlySold(false);
                        }}
                      />
                    </div>
                  </Form>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Form>
                    <div className="filter_header my-1 d-flex justify-content-between align-items-center">
                      Nur inaktive Artikel
                      <Form.Check
                        className=""
                        label=""
                        name="grp-set-only-inactive"
                        type="checkbox"
                        id={`reverse-checkbox-2`}
                        checked={onlyInactive}
                        onChange={(e) => {
                          setOnlyInactive(e.target.checked);
                          setWithInactive(false);
                          setOnlyRetoured(false);
                          setOnlySold(false);
                        }}
                      />
                    </div>
                  </Form>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Form>
                    <div className="filter_header my-1 d-flex justify-content-between align-items-center">
                      Nur retournierte Artikel
                      <Form.Check
                        className=""
                        label=""
                        name="grp-set-only-retoured"
                        type="checkbox"
                        id={`reverse-checkbox-3`}
                        checked={onlyRetoured}
                        onChange={(e) => {
                          setOnlyInactive(false);
                          setWithInactive(false);
                          setOnlySold(false);
                          setOnlyRetoured(e.target.checked);
                        }}
                      />
                    </div>
                  </Form>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Form>
                    <div className="filter_header my-1 d-flex justify-content-between align-items-center">
                      Nur verkaufte Artikel
                      <Form.Check
                        className=""
                        label=""
                        name="grp-set-only-sold"
                        type="checkbox"
                        id={`reverse-checkbox-4`}
                        checked={onlySold}
                        onChange={(e) => {
                          setOnlyInactive(false);
                          setWithInactive(false);
                          setOnlySold(e.target.checked);
                          setOnlyRetoured(false);
                        }}
                      />
                    </div>
                  </Form>
                </ListGroup.Item>
              </React.Fragment>
            )}
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
}

export default Filter;
